import React, { useEffect, useState } from 'react';
import EmailDeliveryStatus, {
  DeliveryStatus,
  IDeliveryStatusGridData,
  IDeliveryStatusProps,
  ReciepientType,
} from '@AMIEWEB/Notification/EmailDeliverStatus/EmailDeliveryStatus';
import { useDispatch } from 'react-redux';
import { GetUserLogs } from 'app/services/NotificationServices/NotificationService';
import { missingField } from 'app/constants';
import { GetMomentOfDate } from 'utils/dates/moment';
import { placementDocumentsActions } from 'store/redux-store/placement-documents/slice';
import { gridSelectionActions } from '@AMIEWEB/Common/Grid/GridSelection/GridSelection.redux';
import { globalActions } from 'app/ApplicationRoot/Global.redux';

const initialModalData: IDeliveryStatusProps = {
  open: false,
  tableData: [],
  subject: '',
  sentDate: [],
  selectedSentDate: undefined,
  body: '',
  closeModal: () => {},
};

export const DeliveryStatusWrapper = props => {
  const dispatch = useDispatch();
  const { openEmailDeliveryModal, logId, setEmailDeliveryModal, emailLogs } = props;

  const [modalData, setModalData] = useState<IDeliveryStatusProps>({
    ...initialModalData,
  });

  const [loader, setLoader] = useState<boolean>(false);

  const handleFetchLogs = async logIds => {
    setLoader(true);
    const res = await GetUserLogs({
      ids: logIds,
      isCandidateCommunication: false,
    });
    if (!res?.results?.length) {
      dispatch(
        globalActions.setSnackBar({
          message: 'Email Delivery Status unavailable at this time. Please try again later.',
          severity: 'error',
        }),
      );
      setEmailDeliveryModal(false);
      dispatch(placementDocumentsActions.setLogId(''));
      dispatch(gridSelectionActions.reset());
      setLoader(false);
      return;
    }
    const tblData: IDeliveryStatusGridData[] = [];
    let idx = 0;
    const tos = (res.results[0].message.tos as any[]).map<IDeliveryStatusGridData>(d => ({
      deliveryStatus: d.deliveryStatus ? d.deliveryStatus : DeliveryStatus.Pending,
      email: d.email,
      error: 0,
      id: `${idx++}`,
      name: d?.name?.length > 1 ? d.name : missingField,
      reciepientType: ReciepientType.Tos,
    }));
    tblData.push(...tos);
    const ccs = (res.results[0].message.ccs as any[]).map<IDeliveryStatusGridData>(d => ({
      deliveryStatus: d.deliveryStatus ? d.deliveryStatus : DeliveryStatus.Pending,
      email: d.email,
      error: 0,
      id: `${idx++}`,
      name: d?.name?.length > 1 ? d.name : missingField,
      reciepientType: ReciepientType.Ccs,
    }));
    tblData.push(...ccs);
    const bccs = (res.results[0].message.bccs as any[]).map<IDeliveryStatusGridData>(d => ({
      deliveryStatus: d.deliveryStatus ? d.deliveryStatus : DeliveryStatus.Pending,
      email: d.email,
      error: 0,
      id: `${idx++}`,
      name: d.name?.length > 1 ? d.name : missingField,
      reciepientType: ReciepientType.Bccs,
    }));
    tblData.push(...bccs);
    const newEmailLogs = emailLogs?.map(log => ({
      date:
        GetMomentOfDate(log.publishedOn).format('MM/DD/YYYY') +
        ' ' +
        'at' +
        ' ' +
        GetMomentOfDate(log.publishedOn).format('LT'),
      logid: log?.id,
    }));
    const filteredLog = emailLogs.filter(log => log?.id === logId)[0];
    const selLog = {
      date:
        GetMomentOfDate(filteredLog.publishedOn).format('MM/DD/YYYY') +
        ' ' +
        'at' +
        ' ' +
        GetMomentOfDate(filteredLog.publishedOn).format('LT'),
      logid: filteredLog?.id,
    };

    const deliveryModalProps: IDeliveryStatusProps = {
      id: res.results[0].id,
      body: res.results[0].message.body,
      open: true,
      subject: res.results[0].message.subject,
      sentDate: [...newEmailLogs],
      selectedSentDate: selLog,
      tableData: tblData,
      attachmentUrls: [...res.results[0]?.message?.attachmentUrls],
      closeModal: () => {
        setEmailDeliveryModal(false);
        dispatch(placementDocumentsActions.setLogId(''));
        dispatch(gridSelectionActions.reset());
      },
    };
    setModalData(deliveryModalProps);
    setLoader(false);
  };

  useEffect(() => {
    if (logId !== '') {
      handleFetchLogs([logId]);
    }
  }, [logId]);

  return (
    <div>
      <EmailDeliveryStatus {...modalData} open={openEmailDeliveryModal} loader={loader} isDocumentsTab/>
    </div>
  );
};
